<template>
  <v-main>
    <head>
      <title>
        Search Results for {{this.$route.params.search_query}} - Foraje
      </title>
    </head>
    <v-divider></v-divider>
    <v-tabs fixed icons-and-text centered slider-color="secondary" v-model="current_tab">
      <!--<v-tab key="products" @click.native="GetProductsResults">
        Products
        <v-icon>mdi-package-variant-closed</v-icon>

      </v-tab> <br>-->
      <v-tab key="people" @click="GetPeopleResults">
        People
        <v-icon>mdi-account-box-multiple</v-icon>

      </v-tab>
      <v-tab key="shops" @click="GetShopsResults">
        Shops/Farmstands
        <v-icon light>mdi-store</v-icon>
      </v-tab>
      <v-tab key="finder" @click="$router.push('/shop-finder/')">
        Map
        <v-icon light>mdi-map-search</v-icon>
      </v-tab>
      <!--<v-tab key="taxa" @click.native="GetTaxaResults">
        Guide
        <v-icon>mdi-file-tree-outline</v-icon>
      </v-tab>-->
      <!--<v-tab-item key="products">
        <v-container >
          <v-row   v-if="areproductsloading">
            <v-col cols="12" class="text-center">
              <v-progress-circular
                      :size="100"
                      :width="7"
                      color="primary"
                      indeterminate
              ></v-progress-circular>
            </v-col>
          </v-row>
          <v-row   v-if="products && products.length" class="hidden-sm-and-up">
            <v-col class="ma-1" cols="12" v-for="product of products" :key="product.id">
              <v-card>
                <v-row>
                  <v-col class="pa-3 ml-3" v-if="product.product_image && product.product_image.length > 0" cols="5" >
                    <v-img
                      :src="product.product_image[0].image.thumbnail"
                      class="FetchedThumbail"
                      aspect-ratio="1"
                    ></v-img>
                  </v-col >
                  <v-col v-else cols="5">
                    <v-img
                      src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                      contain
                      alt="No image found"
                    ></v-img>
                  </v-col>
                  <v-col cols="7" class="pt-1">
                    <v-card-title class="wordbreak">
                      <div style="font-size: medium">
                        <router-link :to="'/products/' + product.slug">
                          {{product.name}}
                        </router-link>
                      </div>

                    </v-card-title>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                  <v-row  >
                    <v-col style="font-size: medium" cols="8">${{product.price.slice(0, -2)}} per {{product.price_units}}</v-col>
                    <v-col v-if="product.external_page" cols="3">
                      <a :href="product.external_page">
                        Buy it Here!
                      </a>
                    </v-col>
                    <v-col v-else cols="3">
                                          <span>
                                                    Not sure where you can buy it, sorry.
                                                  </span>
                    </v-col>
                  </v-row>
                </v-card-actions>

              </v-card>

            </v-col>

            <v-col cols="12" class="text-center">
              <v-btn
                v-if="this.productspageCount > 1"
                @click="ProductsLoadPreviousBatch"
                :loading="areproductsloading"
                class="secondary"
              >
                Previous Product Results
                <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
              </v-btn>
              <v-btn
                v-if="this.productsfullresponse.next !== null"
                @click="ProductsLoadNextBatch"
                :loading="areproductsloading"
                class="primary"
              >

                More Product Results!
                <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row   v-if="products && products.length" class="hidden-xs-only">
            <v-col class="ma-1" sm="3" v-for="product of products" :key="product.id" cols="12">
              <v-card>
                <v-row>
                  <v-col class="pa-3 ml-3" v-if="product.product_image && product.product_image.length > 0" cols="5" >
                    <v-img
                            :src="product.product_image[0].image.thumbnail"
                            class="FetchedThumbail"
                            aspect-ratio="1"
                    ></v-img>
                  </v-col >
                  <v-col v-else cols="5">
                    <v-img
                            src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                            contain
                            alt="No image found"
                    ></v-img>
                  </v-col>
                  <v-col cols="7" class="pt-1">
                    <v-card-title class="wordbreak">
                      <div style="font-size: medium">
                        <router-link :to="'/products/' + product.slug">
                          {{product.name}}
                        </router-link>
                      </div>

                    </v-card-title>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                  <v-row  >
                    <v-col style="font-size: medium" cols="12">${{product.price.slice(0, -2)}} per {{product.price_units}}</v-col>
                    <v-col v-if="product.external_page" cols="12">
                      <a :href="product.external_page">
                        Buy it Here!
                      </a>
                    </v-col>
                    <v-col v-else cols="12">
                                          <span>
                                                    Not sure where you can buy it, sorry.
                                                  </span>
                    </v-col>
                  </v-row>
                </v-card-actions>

              </v-card>

            </v-col>

            <v-col cols="12" class="text-center">
              <v-btn
                      v-if="this.productspageCount > 1"
                      @click="ProductsLoadPreviousBatch"
                      :loading="areproductsloading"
                      class="secondary"
              >
                Previous Product Results
                <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
              </v-btn>
              <v-btn
                      v-if="this.productsfullresponse.next !== null"
                      @click="ProductsLoadNextBatch"
                      :loading="areproductsloading"
                      class="primary"
              >

                More Product Results!
                <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row v-else-if="!areproductsloading">
            <v-col cols="12">
              <v-card xs12 s6 m4 ma-2 hover raised>
                <v-card-title primary-title>
                  <h3>Sorry I got nothin'</h3>
                </v-card-title>
                <v-card-text>
                  <span>I went looking, and couldn't find what you were looking for. Sorry! Try searching for something else, or tell us about the thing we're apparently missing!</span>
                  <br>
                  <p class="hidden-sm-and-up">If you're on mobile, try clicking or tapping the above tabs, instead of swiping. Sorry for the hassle!</p>

                </v-card-text>
              </v-card>
            </v-col>
          </v-row>


        </v-container>
      </v-tab-item>-->


      <v-tab-item key="people">
        <v-container >
          <v-row   v-if="arepeopleloading">
            <v-col cols="12" class="text-center">
              <v-progress-circular
                      :size="100"
                      :width="7"
                      color="primary"
                      indeterminate
              ></v-progress-circular>
            </v-col>
          </v-row>

          <v-row   v-else-if="people && people.length">
            <v-col cols="12" md="4" v-for="person of people" :key="person.id">
              <v-card>
                <router-link v-bind:to="'/profiles/' + person.slug">
                  <v-img
                          v-if="person.profile_image.image && person.profile_image.image.full_size"
                          class="white--text"
                          height="200px"
                          :src="person.profile_image.image.full_size"
                          :lazy-src="person.profile_image.image.thumbnail"
                  >

                  </v-img>
                  <v-img
                          v-else
                          class="white--text"
                          height="200px"
                          src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                          alt="No image found"
                  >
                  </v-img>
                </router-link>
                <v-card-title class="wordbreak">
                    <h2><router-link v-bind:to="'/profiles/' + person.slug"><p><strong>{{person.name}}</strong></p></router-link></h2>
                </v-card-title>
                <v-col cols="12">
                  <span style="display: inline-block"><v-icon>mdi-map-marker</v-icon>{{person.location}}</span>
                </v-col>
                <v-card-text>
                  <p v-if="person.description && person.description.length < 150">{{person.description}}</p> <p v-else>{{person.description.substring(0,150)}}</p>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>


          <v-row v-else>
            <v-col cols="12">
              <v-card xs12 s6 m4 ma-2 hover raised>
                <v-card-title primary-title>
                  <h3>Sorry I got nothin'</h3>
                </v-card-title>
                <v-card-text>
                  <span>I went looking, and couldn't find what you were looking for. Sorry! Try searching for something else, or <router-link :to="'/sign_up/'">Signup to include yourself in this list!</router-link></span>
                  <br>
                  <p class="hidden-sm-and-up">If you're on mobile, try clicking or tapping the above tabs, instead of swiping. Sorry for the hassle!</p>

                </v-card-text>
              </v-card>
            </v-col>
            <!--TODO maybe add some suggestions, or featured things if they don't find what they were looking for? Or is that just in the way?-->
          </v-row>


        </v-container>
      </v-tab-item>
      <v-tab-item key="shops">
        <v-row   v-if="areshopsloading">
          <v-col cols="12" class="text-center">
            <v-progress-circular
              :size="100"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
        <v-row   v-else-if="shops && shops.length">
          <v-col cols="12" md="4" v-for="shop of shops" :key="shop.id">
            <v-card>
              <v-card-title class="wordbreak">
                <h2><router-link v-bind:to="'/shops/' + shop.slug"><p><strong>{{shop.name}}</strong></p></router-link></h2>
              </v-card-title>
              <v-card-text>
                <p v-if="shop.description && shop.description.length < 150">{{shop.description}}</p> <p v-else>{{shop.description.substring(0,150)}}...</p>
              </v-card-text>
            </v-card>

          </v-col>
        </v-row>


        <v-row v-else>
          <v-col cols="12">
            <v-card xs12 s6 m4 ma-2 hover raised>
              <v-card-title primary-title>
                <h3>Sorry I got nothin'</h3>
              </v-card-title>
              <v-card-text>
                <span>I went looking, and couldn't find what you were looking for. Sorry! Try searching for something else, or <router-link :to="'/vendor/'">Signup to include your shop in this list!</router-link></span>
                <br>
                <p class="hidden-sm-and-up">If you're on mobile, try clicking or tapping the above tabs, instead of swiping. Sorry for the hassle!</p>

              </v-card-text>
            </v-card>
          </v-col>
          <!--TODO maybe add some suggestions, or featured things if they don't find what they were looking for? Or is that just in the way?-->
        </v-row>
      </v-tab-item>

    </v-tabs>

  </v-main>

</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    products: [],
    productsfullresponse: [],

    productspageCount: 1,


    people: [],
    peoplefullresponse: [],
    peoplepageCount: 1,


    shops: [],
    shopsfullresponse: [],
    shopspageCount: 1,


    arevarietiesloading: false,
    arespeciesloading: false,
    arecropsloading: false,
    areproductsloading: false,
    arepeopleloading: false,
    areshopsloading: false,
    aretaxaloading: false,


    previousspeciesquery: null,
    previouscropsquery: null,
    previousproductsquery: null,
    previouspeoplequery: null,
    previousshopsquery: null,
    current_tab: null,
    previoustaxaquery: null,

  }),
  methods: {
    GetSearchResults() {
      // So this is a hacky fix in order to reduce the api calls to the backend, it just
      // forces the browser back to the product tab, so the user has to click back on
      // the people tab, which calls their respective methods.
      // Obviously not perfect, and could be frustrating user design, since it would be more intuitive for the
      // search to lookup depending on which tab is open, but I don't wanna deal with that right now.
      // TODO switch to 'If current tab, then GetXResult'
      this.current_tab = 0;
      this.areproductsloading = true;
      this.products = [];
      const query = this.$route.params.search_query;
      return axios.get(`allproducts/?page=1&search=${query}`)
        .then((response) => {
          this.products = response.data.results;
          this.productsfullresponse = response.data;
        })
        .then(() => { this.areproductsloading = false; });
    },
    GetProductsResults() {
      if (this.previousproductsquery !== this.$route.params.search_query) {
        this.areproductsloading = true;
        this.products = [];
        const query = this.$route.params.search_query;
        axios.get(`allproducts/?page=1&search=${query}`)
          .then((response) => {
            this.products = response.data.results;
            this.productsfullresponse = response.data;
          })
          .then(() => { this.areproductsloading = false; })
          .then(() => {
            this.previousproductsquery = this.$route.params.search_query;
          });
      }
    },

    GetMoreProductsResults() {
      this.areproductsloading = true;
      this.products = [];
      const query = this.$route.params.search_query;
      axios.get(`allproducts/?page=${this.productspageCount}&search=${query}`)
        .then((response) => {
          this.products = response.data.results;
          this.productsfullresponse = response.data;
        })
        .then(() => { this.areproductsloading = false; });
    },

    ProductsLoadNextBatch() {
      if (this.productsfullresponse.next != null) {
        this.productspageCount += 1;
        this.GetMoreProductsResults();
      }
    },

    ProductsLoadPreviousBatch() {
      this.productspageCount -= 1;
      this.GetMoreProductsResults();
    },


    GetPeopleResults() {
      if (this.previouspeoplequery !== this.$route.params.search_query) {
        this.current_tab = 0;
        this.arepeopleloading = true;
        this.people = [];
        const query = this.$route.params.search_query;
        axios.get(`users/?search=${query}`)
          .then((response) => {
            this.people = response.data;
          })
          .then(() => { this.arepeopleloading = false; })
          .then(() => {
            this.previouspeoplequery = this.$route.params.search_query;
          });
      }
    },
    GetShopsResults() {
      if (this.previousshopsquery !== this.$route.params.search_query){
        this.areshopsloading = true;
        this.shops = [];
        const query = this.$route.params.search_query;
        axios.get(`shops/?search=${query}`)
          .then((response) => {
            this.shops = response.data;
          })
          .then(() => { this.areshopsloading = false; })
          .then(() => {
            this.previousshopsquery = this.$route.params.search_query;
          });
      }
    },
    GetTaxaResults() {
      if (this.previoustaxaquery !== this.$route.params.search_query){
        this.aretaxaloading = true;
        this.taxa = [];
        const query = this.$route.params.search_query;
        axios.get(`filtered/all_taxa/by/query/${query}`)
          .then((response) => {
            this.taxa = response.data;
            console.log(response);
          })
          .then(() => { this.aretaxaloading = false; })
          .then(() => {
            this.previoustaxaquery = this.$route.params.search_query;
          });
      }
    },
  },
  created() {
    this.GetPeopleResults();
  },
  watch: {
    '$route.params.search_query': function () {
      this.GetPeopleResults();
    },
  },

};
</script>

<style scoped>
  .headline {

    background: rgba(0, 0, 0, 0.75);
    padding: 4px 8px;

  }
  .wordbreak {
    word-break: break-word;
  }
  .FetchedThumbail{
    border-radius: 50%;
  }
  .ProfilePicture{
    border-radius: 50%;
  }
  .ProfilePictureBackground{

  }
  .ProfilePage{
    background: linear-gradient(#2d796b, #468a7e 10%, #8dbbb3 38%, #add1cb 48%, #eaf1f0 62%)
    repeat scroll;
  }
</style>
